import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UtilsService } from "./utils.service";
import { ApiResponse } from "../classes/api-response";
import { map } from "rxjs/operators";
import { BoxCertificate } from "../model/box-certificate";

@Injectable({
  providedIn: 'root'
})
export class BoxCertificatesService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.boxCertificates;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllBoxCertificates(statuses?: string[]): Observable<BoxCertificate[]> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`, { params })
      .pipe(map(value => value.data as BoxCertificate[]));
  }

  public getBoxCertificate(id?: number, statuses?: string[]): Observable<BoxCertificate> {
    const params = UtilsService.buildUrl(statuses);
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${id}`, { params })
      .pipe(map(value => value.data as BoxCertificate));
  }

  public createBoxCertificate(certificate: BoxCertificate): Observable<BoxCertificate> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, certificate)
      .pipe(map(value => value.data as BoxCertificate));
  }

  public updateBoxCertificate(certificate: BoxCertificate): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${certificate.id}`, certificate)
      .pipe(map(() => { }));
  }

  public deleteBoxCertificate(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }

  public associateCertificate(boxId?: number, certificate?: BoxCertificate): Observable<void> {
    return this.http
      .put<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.entities.boxCertificates}`, certificate)
      .pipe(map(() => { }));
  }

  public dissociateCertificate(boxId?: number, certificateId?: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${environment.apiUrl}/${this.entities.boxes}/${boxId}/${this.entities.boxCertificates}/${certificateId}`)
      .pipe(map(() => { }));
  }

}
